yourStaffProgres.vue
<template>
    <div class="container-fluid position-relative bg-BAT">
        <loading v-if="loading !== 0"></loading>
        <div>
            <div class="container watch-container py-4">
                <div>
                    <div class="breadcrumbs-retos d-flex flex-column pb-2">
                        <div>
                            <a href="/home-bat">
                                <img src="/img/icons/homeBread.svg" alt=""/>
                                Home
                            </a>
                            <a id="practica" class="link cursor-pointer link-active-bread"
                               href="/home-bat">Tu avance</a>
                            <span id="optionP" class="d-none color-active-miga"></span>
                        </div>
                    </div>
                    <a class="pb-2 pt-2" href="/home-bat"><img src="/img/icons/regresar.svg" alt="icon"></a>
                </div>
            </div>

            <div class="container mt-4">
                <div>
                    <div class="row">
                        <div class="col-12 col-md-12 col-lg-4 order-1 order-md-1">
                            <div class="header-portfolio d-flex flex-column">
                                <h5 class="text-title-bat mb-2">Tu Avance</h5>
                            </div>
                        </div>
                    </div>

                    <div v-if="activities.length !== 0" class="row d-flex justify-content-center">
                        <div v-for="(activity, index) in activities" :key="index"
                             class="col-12 col-md-6 col-lg-4 mb-3">
                            <div class="bg-white shadow-sm rounded-4 px-0">
                                <div class="position-relative" style="height: 30px;">
                                    <div class="position-absolute top-0 start-0 d-flex align-items-center">
                                        <div class="d-flex align-items-center">
                                            <div class="category p-1 px-2 object-fit-contain rounded-2 text-bat">
                                                <p class="mb-0 text-indigo-darkness fw-bold">
                                                    <small v-if="activity.option  === 'survey'">Encuestas</small>
                                                    <small v-if="activity.option  === 'challenge'">Retos</small>
                                                    <small v-if="activity.option  === 'learning'">Aprendizaje</small>
                                                    <small
                                                        v-if="activity.option  === 'entertainment'">Entretenimiento</small>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="activity.lapse_id !== null"
                                         class="position-absolute top-0 end-0 d-flex align-items-center">
                                        <div class="ticket_season_staff p-1 px-2 object-fit-contain rounded-1">
                                            <p class="mb-0 text-black"><img
                                                src="/img-version2/icons/staff/Llamas%2024x24.svg" alt=""><b><small><strong>En Racha</strong></small></b>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="px-3 pb-4">
                                    <div class="col-7 text-start my-3">
                                        <div v-if="activity.option === 'learning'">
                                            <span class="bg-darkblue text-white py-1 px-2 rounded-2 fs-6 mb-0 text-bat"
                                                  v-if="activity.users.length === 0">
                                                ● Por iniciar
                                            </span>
                                            <span class="bg-orange text-white py-1 px-2 rounded-2 fs-6 mb-0 text-bat"
                                                  v-else-if="activity.users[0].pivot.status === 'pending'">
                                                ● Incompleto
                                            </span>
                                            <span
                                                class="status-complete-box text-white py-1 px-2 rounded-2 fs-6 mb-0 text-bat"
                                                v-else-if="activity.users[0].pivot.status === 'completed'">
                                                ● Completado
                                            </span>
                                        </div>
                                        <div v-if="activity.option === 'survey'">
                                            <span class="bg-darkblue text-white py-1 px-2 rounded-2 fs-6 mb-0 text-bat"
                                                  v-if="activity.client_survey.length === 0">
                                                ● Por iniciar
                                            </span>
                                            <span class="bg-orange text-white py-1 px-2 rounded-2 fs-6 mb-0 text-bat"
                                                  v-else-if=" activity.client_survey[0].status === 'pending'">
                                                ● Incompleto
                                            </span>
                                            <span
                                                class="status-complete-box text-white py-1 px-2 rounded-2 fs-6 mb-0 text-bat"
                                                v-else-if=" activity.client_survey[0].status === 'finish'">
                                                ● Completado
                                            </span>
                                        </div>
                                        <div v-if="activity.option === 'challenge'">
                                            <span class="bg-darkblue text-white py-1 px-2 rounded-2 fs-6 mb-0 text-bat"
                                                  v-if="activity.client.length === 0 || activity.client[0].pivot.is_approved === 'read'">
                                                ● Por iniciar
                                            </span>
                                            <span class="bg-orange text-white py-1 px-2 rounded-2 fs-6 mb-0 text-bat"
                                                  v-else-if=" activity.client[0].pivot.is_approved === 'review'">
                                                ● En revisión
                                            </span>
                                            <span
                                                class="status-complete-box text-white py-1 px-2 rounded-2 fs-6 mb-0 text-bat"
                                                v-else-if=" activity.client[0].pivot.is_approved === 'true'">
                                                ● Completado
                                            </span>
                                            <span class="bg-danger text-white py-1 px-2 rounded-2 fs-6 mb-0 text-bat"
                                                  v-else-if=" activity.client[0].pivot.is_approved === 'false'">
                                                ● No aprobado
                                            </span>
                                        </div>
                                        <div v-if="activity.option === 'entertainment'">
                                            <span class="bg-darkblue text-white py-1 px-2 rounded-2 fs-6 mb-0 text-bat"
                                                  v-if="activity.client.length === 0">
                                                ● Por iniciar
                                            </span>
                                            <span
                                                class="status-complete-box text-white py-1 px-2 rounded-2 fs-6 mb-0 text-bat"
                                                v-else-if=" activity.client[0].pivot.status === 'true'">
                                                ● Completado
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-12 mb-2">
                                        <h6 v-if="activity.name" class="text-title-bat">
                                            {{ activity.name }}
                                        </h6>
                                        <h6 v-else-if="activity.title" class="text-title-bat">
                                            {{ activity.title }}
                                        </h6>
                                        <h6 v-else-if="activity.challenge_name" class="text-title-bat">
                                            {{ activity.challenge_name }}
                                        </h6>
                                    </div>
                                    <div v-if="activity.option === 'learning'">
                                        <div class="text-bat" v-if="activity.users.length === 0">
                                            <div v-if="activity.in_warning" class="mb-1">
                                                <img src="/img-version2/icons/season-staff/season-current.gif" alt="" style="width: 30px !important;"> Tu racha está en juego
                                            </div>
                                            <div v-else class="mb-1">
                                                <span v-if="isLinked">¡No pierdas {{ activity.points_to_win }} puntos!</span>
                                            </div>
                                            <div class="mb-1">
                                                Fecha de vencimiento : {{ formatDate(activity.expiration_date_end) }}
                                            </div>
                                            <div class="col-12 mt-2 text-end " style="font-size: 20px !important;">
                                                <a :href="cardLinkAndStatus(activity).activityUrl">Ingresa Ahora <img src="/img-version2/icons/staff/arrow-right-blue.svg" alt="arrow-right">
                                                </a>
                                            </div>
                                        </div>
                                        <div class="text-bat" v-else-if="activity.users[0].pivot.status === 'pending'">
                                            <div v-if="activity.in_warning" class="mb-1">
                                                <img src="/img-version2/icons/season-staff/season-current.gif" alt="" style="width: 30px !important;"> Tu racha está en juego
                                            </div>
                                            <div v-else class="mb-1">
                                                <span v-if="isLinked">¡No pierdas {{ activity.points_to_win }} puntos!</span>
                                            </div>
                                            <div class="mb-1">
                                                Fecha de vencimiento : {{ formatDate(activity.expiration_date_end) }}
                                            </div>
                                            <div class="col-12 mt-2 text-end " style="font-size: 20px !important;">
                                                <a :href="cardLinkAndStatus(activity).activityUrl">Ingresa Ahora <img src="/img-version2/icons/staff/arrow-right-blue.svg" alt="arrow-right">
                                                </a>
                                            </div>
                                        </div>
                                        <div class="text-bat"
                                             v-else-if="activity.users[0].pivot.status === 'completed'">
                                            ¡Buen Trabajo!
                                        </div>
                                    </div>
                                    <div v-if="activity.option === 'survey'">
                                        <div class="text-bat" v-if="activity.client_survey.length === 0">
                                            <div v-if="activity.in_warning" class="mb-1">
                                                <img src="/img-version2/icons/season-staff/season-current.gif" alt="" style="width: 30px !important;"> Tu racha está en juego
                                            </div>
                                            <div v-else class="mb-1">
                                                <span v-if="isLinked">¡No pierdas {{ activity.points_to_win }} puntos!</span>
                                            </div>
                                            <div class="mb-1">
                                                Fecha de vencimiento : {{ formatDate(activity.expiration_date_end) }}
                                            </div>
                                            <div class="col-12 mt-2 text-end " style="font-size: 20px !important;">
                                                <a :href="cardLinkAndStatus(activity).activityUrl">Ingresa Ahora <img src="/img-version2/icons/staff/arrow-right-blue.svg" alt="arrow-right">
                                                </a>
                                            </div>
                                        </div>
                                        <div class="text-bat"
                                             v-else-if=" activity.client_survey[0].status === 'pending'">
                                            <div v-if="activity.in_warning" class="mb-1">
                                                <img src="/img-version2/icons/season-staff/season-current.gif" alt="" style="width: 30px !important;"> Tu racha está en juego
                                            </div>
                                            <div v-else class="mb-1">
                                                <span v-if="isLinked">¡No pierdas {{ activity.points_to_win }} puntos!</span>
                                            </div>
                                            <div class="mb-1">
                                                Fecha de vencimiento : {{ formatDate(activity.expiration_date_end) }}
                                            </div>
                                            <div class="col-12 mt-2 text-end " style="font-size: 20px !important;">
                                                <a :href="cardLinkAndStatus(activity).activityUrl">Ingresa Ahora <img src="/img-version2/icons/staff/arrow-right-blue.svg" alt="arrow-right">
                                                </a>
                                            </div>
                                        </div>
                                        <div class="text-bat"
                                             v-else-if=" activity.client_survey[0].status === 'finish'">
                                            ¡Buen Trabajo!
                                        </div>
                                    </div>
                                    <div v-if="activity.option === 'challenge'">
                                        <div class="text-bat"
                                             v-if="activity.client.length === 0 || activity.client[0].pivot.is_approved === 'read'">
                                            <div v-if="activity.in_warning" class="mb-1">
                                                <img src="/img-version2/icons/season-staff/season-current.gif" alt="" style="width: 30px !important;"> Tu racha está en juego
                                            </div>
                                            <div v-else class="mb-1">
                                                <span v-if="isLinked">¡No pierdas {{ activity.points_to_win }} puntos!</span>
                                            </div>
                                            <div class="mb-1">
                                                Fecha de vencimiento : {{ formatDate(activity.expiration_date_end) }}
                                            </div>
                                            <div class="col-12 mt-2 text-end " style="font-size: 20px !important;">
                                                <a :href="cardLinkAndStatus(activity).activityUrl">Ingresa Ahora <img src="/img-version2/icons/staff/arrow-right-blue.svg" alt="arrow-right">
                                                </a>
                                            </div>
                                        </div>
                                        <div class="text-bat"
                                             v-else-if=" activity.client[0].pivot.is_approved === 'review'">
                                            <div v-if="activity.in_warning" class="mb-1">
                                                <img src="/img-version2/icons/season-staff/season-current.gif" alt="" style="width: 30px !important;"> Tu racha está en juego
                                            </div>
                                            <div v-else class="mb-1">
                                                <span v-if="isLinked">¡No pierdas {{ activity.points_to_win }} puntos!</span>
                                            </div>
                                            <div class="mb-1">
                                                Fecha de vencimiento : {{ formatDate(activity.expiration_date_end) }}
                                            </div>
                                            <div class="col-12 mt-2 text-end " style="font-size: 20px !important;">
                                                <a :href="cardLinkAndStatus(activity).activityUrl">Ingresa Ahora <img src="/img-version2/icons/staff/arrow-right-blue.svg" alt="arrow-right">
                                                </a>
                                            </div>
                                        </div>
                                        <div class="text-bat"
                                             v-else-if=" activity.client[0].pivot.is_approved === 'true'">
                                            ¡Buen Trabajo!
                                        </div>
                                        <div class="text-bat"
                                             v-else-if=" activity.client[0].pivot.is_approved === 'false'">
                                            No aprobado
                                        </div>
                                    </div>
                                    <div v-if="activity.option === 'entertainment'">
                                        <div class="text-bat"
                                             v-if="activity.client.length === 0">
                                            <div v-if="activity.in_warning" class="mb-1">
                                                <img src="/img-version2/icons/season-staff/season-current.gif" alt="" style="width: 30px !important;"> Tu racha está en juego
                                            </div>
                                            <div v-else class="mb-1">
                                                <span v-if="isLinked">¡No pierdas {{ activity.points_to_win }} puntos!</span>
                                            </div>
                                            <div class="mb-1">
                                                Fecha de vencimiento : {{ formatDate(activity.expiration_date_end) }}
                                            </div>
                                            <div class="col-12 mt-2 text-end " style="font-size: 20px !important;">
                                                <a :href="cardLinkAndStatus(activity).activityUrl">Ingresa Ahora <img src="/img-version2/icons/staff/arrow-right-blue.svg" alt="arrow-right">
                                                </a>
                                            </div>
                                        </div>
                                        <div class="text-bat"
                                             v-else-if=" activity.client[0].pivot.status === 'true'">
                                            ¡Buen Trabajo!
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-else class="row">
                        <no-data-staff
                            :title="'¡Todo al día!'"
                            :description="'Tu Staff no tiene actividades pendientes por ahora.'"
                        ></no-data-staff>
                    </div>

                </div>


            </div>
        </div>

    </div>
</template>

<script>

export default {
    props: {
        client_id: {
            default: null
        },
        client_segment: {
            default: null,
        },
    },
    data() {
        return {
            loading: 0,
            activities: [],
            getWidth() {
                if (this.$mq === 'sm') {
                    return '95%';
                } else if (this.$mq === 'md') {
                    return '35%';
                } else if (this.$mq === 'lg') {
                    return '30%';
                } else {
                    return '20%';
                }
            },
            collapseStates: {},
            showAlert: false,
            isLinked: false,
        };
    },

    mounted() {
        this.getWinPoints();
        this.validateLinkingDate();
    },
    methods: {
        getWinPoints() {
            this.loading++;
            axios.get(`/get-your-progress-activities`).then(({data}) => {
                this.activities = data.data;
                this.loading--;
            });
        },
        formatDate(date) {
            const d = new Date(date);
            return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
        },
        returnChallenges(type, id) {
            let challenge = '';
            switch (type) {
                case 'photo':
                    challenge = `retos/foto/${id}`;
                    break;
                case 'video':
                    challenge = `retos/video/${id}`;
                    break;
                case 'audio':
                    challenge = ``;
                    break;
                case 'alphabet-soup':
                    challenge = `retos/sopa-letras/${id}}`;
                    break;
                case 'crossword':
                    challenge = `retos/crucigrama/${id}}`;
                    break;
                case 'uniq-question':
                    challenge = `retos/only-answer/${id}`;
                    break;
                case 'open-question':
                    challenge = `retos/free-answer/${id}`;
                    break;
                case 'memento':
                    challenge = `retos/memento/${id}`;
                    break;
            }
            return challenge;
        },

        cardLinkAndStatus(card) {
            const { id } = card
            let activityStatus = ''
            let activityUrl = '#'
            let showExpirationDate = true

            switch (card.option) {
                case 'learning':
                    if (card.users.length === 0 || (!card.has_quiz && card.users[0].pivot.status === 'pending')) {
                        activityStatus = 'Comenzar'
                        activityUrl = `/learning/${id}`
                    } else if (card.has_quiz && card.users[0].pivot.status === 'pending') {
                        activityStatus = 'Reanudar'
                        activityUrl = `/learning/${id}`
                    } else if (card.users[0].pivot.status === 'completed') {
                        activityStatus = 'Volver a ver'
                        activityUrl = `/learning/${id}`
                        showExpirationDate = false

                        if (card.has_quiz && card.users.length) {
                            if (card.users[0].pivot.quiz_presented === 0) {
                                activityStatus = 'Presentar quiz'
                                activityUrl = `/learning/${id}/quiz`
                                showExpirationDate = true
                            } else if (card.users[0].pivot.score === null) {
                                activityStatus = 'Retroalimentación'
                                activityUrl = '#'
                            } else if (card.users[0].pivot.score != null) {
                                activityStatus = 'Retroalimentación'
                                activityUrl = `/learning/${id}/quiz/feedback`
                            }
                        }
                    }

                    return { activityStatus, activityUrl, showExpirationDate }

                case 'survey':
                    if (card.client_survey.length === 0 || card.client_survey[0] == []) {
                        activityStatus = 'Comenzar'
                        activityUrl = `/survey/${id}`
                    } else if (card.client_survey[0].status === 'pending') {
                        activityStatus = 'Continuar'
                        activityUrl = `/survey/${id}`
                    } else if (card.client_survey[0].status === 'finish') {
                        showExpirationDate = false
                    }

                    return { activityStatus, activityUrl, showExpirationDate }

                case 'challenge':
                    if (card.client && card.client.length === 0 || card.client[0].pivot.is_approved === 'read') {
                        activityStatus = 'Comenzar'
                        activityUrl = this.returnChallenges(card.challenge_type_name, id)
                    } else {
                        showExpirationDate = false
                    }

                    return { activityStatus, activityUrl, showExpirationDate }

                case 'entertainment':
                    activityStatus = 'Comenzar';
                    activityUrl = `/entertainment/search_character/${id}`;

                    if (card.client && card.client.length > 0 && card.client[0].pivot.status === 'true') {
                        activityStatus = '';
                        activityUrl = '#';
                        showExpirationDate = false;
                    } else if (card.client.length === 0) {
                        activityStatus = 'Comenzar';
                        activityUrl = `/entertainment/search_character/${id}`;
                        showExpirationDate = true;
                    }
                    return { activityStatus, activityUrl, showExpirationDate }
            }
        },
        validateLinkingDate(){
            axios
                .get(`/validate-linking-date`)
                .then(({ data }) => {
                    this.isLinked = data.is_linked;
                })
                .catch(error => {
                    console.error('Error al obtener el estado de vinculación al punto de venta:', error);
                    this.isLinked = false;
                });
        },
    }
};
</script>
